/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_AnalyzingInputs */

const en_deep_match_analyzing = /** @type {(inputs: Deep_Match_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const de_deep_match_analyzing = /** @type {(inputs: Deep_Match_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const fr_deep_match_analyzing = /** @type {(inputs: Deep_Match_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const es_deep_match_analyzing = /** @type {(inputs: Deep_Match_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const it_deep_match_analyzing = /** @type {(inputs: Deep_Match_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const nl_deep_match_analyzing = /** @type {(inputs: Deep_Match_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const pl_deep_match_analyzing = /** @type {(inputs: Deep_Match_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const fi_deep_match_analyzing = /** @type {(inputs: Deep_Match_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const da_deep_match_analyzing = /** @type {(inputs: Deep_Match_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const sv_deep_match_analyzing = /** @type {(inputs: Deep_Match_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

/**
* | output |
* | --- |
* | "Analyzing..." |
*
* @param {Deep_Match_AnalyzingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_analyzing = /** @type {((inputs?: Deep_Match_AnalyzingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_AnalyzingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_analyzing(inputs)
	if (locale === "fr") return fr_deep_match_analyzing(inputs)
	if (locale === "es") return es_deep_match_analyzing(inputs)
	if (locale === "it") return it_deep_match_analyzing(inputs)
	if (locale === "nl") return nl_deep_match_analyzing(inputs)
	if (locale === "pl") return pl_deep_match_analyzing(inputs)
	if (locale === "fi") return fi_deep_match_analyzing(inputs)
	if (locale === "da") return da_deep_match_analyzing(inputs)
	if (locale === "sv") return sv_deep_match_analyzing(inputs)
	return en_deep_match_analyzing(inputs)
});